import { configuration } from "@/configuration";
import { CompanyPricingPlan, Currency, Locale } from "@lib";

/** Бизнес-логика тарифных планов. */
export abstract class PricingLogic {
    /** Название тарифного плана. */
    public static getPricingPlanTitle(pricingPlan: CompanyPricingPlan): string {
        switch (pricingPlan) {
            case CompanyPricingPlan.Standart:
                return "Стандартный";
            case CompanyPricingPlan.SC24:
                return "Миграция с SC24";
            case CompanyPricingPlan.UposStandart:
                return "Стандартный";
            case CompanyPricingPlan.Free10:
            default:
                return `Знакомство с ${configuration.about.title}`;
        }
    }

    /** Цена тарифного плана. */
    public static getPricingPlanPrice(pricingPlan: CompanyPricingPlan): number {
        switch (pricingPlan) {
            case CompanyPricingPlan.Standart:
                return configuration.prices.standart.fee;
            case CompanyPricingPlan.SC24:
                return configuration.prices.sc24.fee;
            case CompanyPricingPlan.UposStandart:
                return configuration.prices.uposStandart.fee;
            case CompanyPricingPlan.Free10:
            default:
                return configuration.prices.free.fee;
        }
    }

    /** Валюта тарифного плана. */
    public static getPricingPlanCurrency(pricingPlan: CompanyPricingPlan): Currency {
        switch (pricingPlan) {
            case CompanyPricingPlan.Standart:
                return configuration.prices.standart.currency;
            case CompanyPricingPlan.SC24:
                return configuration.prices.sc24.currency;
            case CompanyPricingPlan.UposStandart:
                return configuration.prices.uposStandart.currency;
            case CompanyPricingPlan.Free10:
            default:
                return configuration.prices.free.nextPlan
                    ? this.getPricingPlanCurrency(configuration.prices.free.nextPlan)
                    : configuration.prices.free.currency;
        }
    }

    /** Языковой стандарт тарифного плана. */
    public static getPricingPlanLocale(pricingPlan: CompanyPricingPlan): Locale {
        switch (pricingPlan) {
            case CompanyPricingPlan.Standart:
                return configuration.prices.standart.locale;
            case CompanyPricingPlan.SC24:
                return configuration.prices.sc24.locale;
            case CompanyPricingPlan.UposStandart:
                return configuration.prices.uposStandart.locale;
            case CompanyPricingPlan.Free10:
            default:
                return configuration.prices.free.nextPlan
                    ? this.getPricingPlanLocale(configuration.prices.free.nextPlan)
                    : configuration.prices.free.locale;
        }
    }

    /** Будущий тарифный план. */
    public static getNextPricingPlan(pricingPlan: CompanyPricingPlan): CompanyPricingPlan {
        if (CompanyPricingPlan.Free10) {
            return configuration.prices.free.nextPlan;
        }

        return pricingPlan;
    }
}
